import React, { useCallback } from 'react'
import type { AiChatDockLayout } from '@ai-chat-widget-contracts/contracts'
import { defaultStrings } from '@ai-chat-widget/default-strings'
import { toast } from '@/modules/base/components/toast/toastConfig'
import AiChatWidgetLoader from './ai-chat-widget-loader'
import AiChatEntryLegacy from './ai-chat-entry-legacy'
import AiWidgetErrorBoundary from './error-boundary'

export default function AiChatEntryRemote({ onDockLayoutChange }: { onDockLayoutChange?: (layout: AiChatDockLayout) => void }) {
  const notifyRemoteWidgetFailure = useCallback(() => {
    // The legacy chat remains available for recovery, but it does not expose the
    // remote widget's tenant-quota view. Make this degraded mode explicit.
    toast.showToast({ type: 'error', message: defaultStrings.ai.chat.errors.serviceUnavailable })
  }, [])

  return (
    <AiWidgetErrorBoundary
      fallback={<AiChatEntryLegacy initialOpen onDockLayoutChange={onDockLayoutChange} />}
      onError={notifyRemoteWidgetFailure}>
      <AiChatWidgetLoader onDockLayoutChange={onDockLayoutChange} />
    </AiWidgetErrorBoundary>
  )
}
